/* @flow */

import * as React from 'react';
import {PageContainerContext} from 'shells/layout';

import {EditableLabel} from '../editable-label';
import {ButtonGroup} from '../button-group';
import {PageTitleBarTitle} from './page-title-bar-title';
import type {Breadcrumb} from './page-title-breadcrumbs';
import './page-title-bar.css';

export type Props = {
    title: string,
    subheaderPrimaryText: string | React.Node,
    icon: React.ComponentType<*>,
    buttons?: React.Node,
    isModified?: boolean,
    breadcrumbs?: Breadcrumb[],
    noMaxWidth?: boolean,
    subheaderSecondaryText?: string,
    // Pass these props if the title can be renamed in place
    editInPlaceProps?: {
        onChange: (newValue: ?string) => Promise<*> | void,
        placeholder: string,
    },
};

export function PageTitleBar(props: Props) {
    const [titleValue, setTitleValue] = React.useState(props.title);

    React.useEffect(() => {
        setTitleValue(props.title);
    }, [props.title]);

    const {editInPlaceProps} = props;

    return (
        <PageContainerContext.Consumer>
            {({flashBanner}) => {
                return (
                    <>
                        <header styleName='page-title-bar'>
                            <PageTitleBarTitle
                                title={titleValue}
                                titleComponent={
                                    editInPlaceProps ? (
                                        <EditableLabel
                                            value={titleValue}
                                            onSaveNewValue={(newValue) => {
                                                setTitleValue(newValue);

                                                // $FlowIgnore This won't be null
                                                return editInPlaceProps.onChange(newValue);
                                            }}
                                            placeholder={editInPlaceProps.placeholder}
                                            shouldAllowUndo={false}
                                            allowSavingEmpty={false}
                                        />
                                    ) : (
                                        undefined
                                    )
                                }
                                breadcrumbs={props.breadcrumbs}
                                subheaderPrimaryText={props.subheaderPrimaryText}
                                isModified={props.isModified}
                                subheaderSecondaryText={props.subheaderSecondaryText}
                                icon={props.icon}
                                noMaxWidth={props.noMaxWidth}
                                isEditable={Boolean(props.editInPlaceProps)}
                            />
                            {props.buttons ? <ButtonGroup>{props.buttons}</ButtonGroup> : null}
                        </header>
                        {flashBanner ? (
                            <div styleName='app-flash-banner'>{flashBanner}</div>
                        ) : (
                            undefined
                        )}
                    </>
                );
            }}
        </PageContainerContext.Consumer>
    );
}
